import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 150px 300px 300px;
  grid-gap: 10px;
`;
